import React from 'react';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import { getPlaybookById } from '../../../data/playbookTaxonomy';
import { 
  RocketLaunchIcon,
  ChatBubbleLeftRightIcon,
  MagnifyingGlassIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

const ResettingBehavioursHowToExecute = () => {
  const playbook = getPlaybookById('resetting-behaviours');
  const stages = playbook.sections.filter(section => section.id.startsWith('stage-'));

  const stageIcons = {
    'stage-1': <ChatBubbleLeftRightIcon className="h-7 w-7 text-primary-light" />,
    'stage-2': <MagnifyingGlassIcon className="h-7 w-7 text-primary-light" />,
    'stage-3': <SparklesIcon className="h-7 w-7 text-primary-light" />
  };

  return (
    <div className="space-y-8">
      <PlaybookSection
        title="How To Execute"
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
        heading="Step-by-step guide to resetting behaviours"
      >
        <div className="prose prose-invert max-w-none">
          <p className="text-gray-300">
            This playbook provides a structured approach to addressing and resetting behaviors that don't align with your organization's values. Each stage builds upon the previous one, creating a comprehensive process for cultural realignment.
          </p>
        </div>

        <StageCards
          stages={stages}
          icons={stageIcons}
          playbookId="resetting-behaviours"
          introText="Click into each stage to find detailed guidance on implementation. If you need help or have questions, please reach out."
        />

        <div className="mt-8 p-6 bg-gray-800/30 rounded-lg border border-gray-700/50">
          <h3 className="text-lg font-semibold text-white mb-2">Need Help?</h3>
          <p className="text-gray-300">
            If you have any questions or need assistance implementing this playbook, please don't hesitate to reach out to our team at{' '}
            <a href="mailto:john@openorg.fyi" className="text-primary hover:text-primary-light">
              john@openorg.fyi
            </a>
          </p>
        </div>
      </PlaybookSection>
    </div>
  );
};

export default ResettingBehavioursHowToExecute; 